import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row rounded-2xl overflow-hidden border border-background-200/70">
          <div className="lg:w-1/2 relative min-h-[300px] lg:min-h-[480px]">
            <img
              src="https://readdy.ai/api/search-image?query=Minimalist%20workspace%20with%20a%20laptop%20showing%20a%20clean%20spreadsheet%20layout%2C%20next%20to%20a%20cup%20of%20coffee%20and%20product%20samples%20in%20neutral%20boxes%2C%20warm%20cream%20desk%20surface%2C%20soft%20morning%20light%2C%20editorial%20style%2C%20no%20text%20visible%2C%20no%20logos%2C%20commercial%20photography%20in%20warm%20neutral%20tones&width=800&height=600&seq=cta-sheet-v2&orientation=landscape"
              alt="AllChinaBuySpreadsheet on laptop"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8 md:p-10">
              <p className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
                Get
                <br />
                Your
                <br />
                Sheet
              </p>
            </div>
          </div>

          <div className="lg:w-1/2 bg-background-50 flex items-center p-8 md:p-14">
            <div>
              <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-6">
                Start Sourcing
                <br />
                Smarter Today
              </h2>
              <p className="text-base text-foreground-600 leading-relaxed mb-8 max-w-md">
                Stop wasting hours on manual research. Get the AllChinaBuySpreadsheet now — updated listings,
                verified suppliers, and trending products all in one place. Join thousands of sellers who
                already source smarter with our structured data approach.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-10">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap text-center cursor-pointer"
                >
                  Buy It Now
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-full sm:w-auto px-8 py-3.5 border border-foreground-300 text-foreground-800 rounded-full text-base font-semibold hover:bg-background-100 transition-all duration-300 whitespace-nowrap text-center cursor-pointer"
                >
                  AllChinaBuy Sheet
                </a>
              </div>

              <Link
                to="/article/allchinabuyspreadsheet-complete-guide-2026"
                className="inline-flex items-center gap-2 text-sm font-semibold text-accent-600 hover:text-accent-700 transition-colors whitespace-nowrap"
              >
                Read the Full Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}